import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  dashboardData: {},
  analytics: {},
  loading: false,
  isError: false,
  errorMessage: "",
  lastUpdated: null,
  // Dashboard metrics
  totalUsers: 0,
  activeUsers: 0,
  totalSubscriptions: 0,
  totalRevenue: 0,
  apiUsage: 0,
  systemHealth: "good",
  recentActivities: [],
  alerts: [],
};

const adminDashboardSlice = createSlice({
  name: "ADMIN_DASHBOARD",
  initialState: initial_state,
  reducers: {
    updateAdminDashboard: (state, { payload }) => {
      return { ...state, ...payload };
    },
    addUser: (state, { payload }) => {
    state.dashboardData= {...state.dashboardData,totalUsers: state.dashboardData.totalUsers+1}
    },
    setDashboardData: (state, { payload }) => {
      state.dashboardData = payload;
      state.lastUpdated = new Date().toISOString();
    },
    setAnalytics: (state, { payload }) => {
      state.analytics = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.isError = true;
      state.errorMessage = payload;
    },
    clearError: (state) => {
      state.isError = false;
      state.errorMessage = "";
    },
    updateMetrics: (state, { payload }) => {
      state.totalUsers = payload.totalUsers || state.totalUsers;
      state.activeUsers = payload.activeUsers || state.activeUsers;
      state.totalSubscriptions = payload.totalSubscriptions || state.totalSubscriptions;
      state.totalRevenue = payload.totalRevenue || state.totalRevenue;
      state.apiUsage = payload.apiUsage || state.apiUsage;
      state.systemHealth = payload.systemHealth || state.systemHealth;
    },
    addRecentActivity: (state, { payload }) => {
      state.recentActivities.unshift(payload);
      // Keep only last 50 activities
      if (state.recentActivities.length > 50) {
        state.recentActivities = state.recentActivities.slice(0, 50);
      }
    },
    addAlert: (state, { payload }) => {
      state.alerts.unshift(payload);
    },
    removeAlert: (state, { payload }) => {
      state.alerts = state.alerts.filter(alert => alert.id !== payload);
    },
  },
});

export const {
  updateAdminDashboard,
  setDashboardData,
  setAnalytics,
  setLoading,
  setError,
  clearError,
  updateMetrics,
  addRecentActivity,
  addAlert,
  removeAlert,
  addUser
} = adminDashboardSlice.actions;
export default adminDashboardSlice.reducer;
